// Share this information with book keeper.
// This fetches all data from freelancer_basic_info and freelancer_subscription_info, but i have displayed only the ones required by book-keeper

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

import React, { useEffect, useState } from 'react';
import axios from 'axios';



const BKFreelancerPayInDataPage = () => {
  console.log("✅ Component rendering: FreelancerBasicInfoPage");

  const [freelancerInfo, setFreelancerInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc');

  const [searchId, setSearchId] = useState('');
  const [searchName, setSearchName] = useState('');
  const [searchPhone, setSearchPhone] = useState('');
  const [filterState, setFilterState] = useState('');
  const [filterCity, setFilterCity] = useState('');
  const [showBookKeeperView, setShowBookKeeperView] = useState(false);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
  console.log("🌐 API Base URL:", apiBaseURL);

  // Define columns with explicit data keys
  const columns = [
    { header: 'Freelancer ID', key: 'id' },
    { header: 'Name', key: 'name' },
    { header: 'Email', key: 'email' },
    { header: 'Phone', key: 'phone' },
    { header: 'State', key: 'state' },
    { header: 'City', key: 'city' },
    { header: 'Gender', key: 'gender' },
    { header: 'DOB', key: 'dob' },
    { header: 'Qualification', key: 'qualification' },
    { header: 'Content Writing Experience', key: 'content_writing_experience' },
    { header: 'Password', key: 'password' },
    { header: 'Created At', key: 'created_at' },

    // Subscription columns
    { header: 'Subscription Plan', key: 'subscription_plan' },
    { header: 'Subscribed At', key: 'subscribed_at' },
    { header: 'Validity From', key: 'subscription_validity_from' },
    { header: 'Validity To', key: 'subscription_validity_to' },
    { header: 'Subscription price Before GST', key: 'subscription_fees_before_gst' },
    { header: 'Subscription GST Amount', key: 'subscription_gst_amount' },
    { header: 'Subscription price With GST', key: 'subscription_fees_with_gst' },
    { header: 'Payment Date', key: 'payment_date' },
    { header: 'Payment Status', key: 'subscription_fees_payment_status' },
    { header: 'Invoice Number', key: 'invoice_number' },
    { header: 'Subscription ID', key: 'subscription_id' }
  ];
const getVisibleColumns = () => {
  if (showBookKeeperView) {
    const excludedKeys = ['gender', 'dob', 'qualification', 'password', 'subscription_validity_from', 'subscription_validity_to', 'email', 'content_writing_experience' ,'phone', 'created_at', 'city', 'subscribed_at'];
    return columns.filter(col => !excludedKeys.includes(col.key));
  }
  return columns;
};

  useEffect(() => {
    const fetchFreelancerInfo = async () => {
      const token = localStorage.getItem('employeeToken');
      if (!token) {
        window.location.href = "/employee-login";
        return;
      }

      try {
        console.log("📦 GURU calling /api/bk-freelancer-payin-data");
        const response = await axios.get(
          `${apiBaseURL}/api/bk-freelancer-payin-data`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        console.log("📦 Raw data from backend:", response.data);
        setFreelancerInfo(response.data);
      } catch (err) {
        setError('Failed to fetch freelancer basic info.');
      } finally {
        setLoading(false);
      }
    };

    fetchFreelancerInfo();
  }, [apiBaseURL]);

  if (loading) return <div>Loading freelancer info...</div>;
  if (error) return <div>{error}</div>;

  const mappedData = freelancerInfo.map(freelancer => ({
    id: freelancer.freelancer_id ?? '',
    name: freelancer.name ?? '',
    email: freelancer.email ?? '',
    phone: freelancer.phone ?? '',
    state: freelancer.state ?? '',
    city: freelancer.city ?? '',
    gender: freelancer.gender ?? '',
    dob: freelancer.date_of_birth ? new Date(freelancer.date_of_birth).toLocaleDateString() : '',
    qualification: freelancer.highest_qualification ?? '',
    content_writing_experience: freelancer.content_writing_experience ?? '',
    password: freelancer.password ?? '',
    created_at: freelancer.created_at ? new Date(freelancer.created_at).toLocaleString() : '',
    // Subscription info (nullable)
    subscription_plan: freelancer.subscription_plan_name ?? '',
    subscribed_at: freelancer.subscribed_at_time ? new Date(freelancer.subscribed_at_time).toLocaleString() : '',
    subscription_validity_from: freelancer.subscription_validity_from ? new Date(freelancer.subscription_validity_from).toLocaleDateString() : '',
    subscription_validity_to: freelancer.subscription_validity_to ? new Date(freelancer.subscription_validity_to).toLocaleDateString() : '',
    subscription_fees_before_gst: freelancer.subscription_fees_before_gst ?? '',
    subscription_gst_amount: freelancer.subscription_gst_amount ?? '',
    subscription_fees_with_gst: freelancer.subscription_fees_with_gst ?? '',
    payment_date: freelancer.payment_date ? new Date(freelancer.payment_date).toLocaleString() : '',
    subscription_fees_payment_status: freelancer.subscription_fees_payment_status ?? '',
    invoice_number: freelancer.invoice_number ?? '',
    subscription_id: freelancer.subscription_id ?? '',
  }));

  // Get unique states & cities for dropdown
  const uniqueStates = [...new Set(mappedData.map(item => item.state))].filter(Boolean);
  const uniqueCities = [...new Set(mappedData.map(item => item.city))].filter(Boolean);

  // Apply chained filters
  const filteredData = mappedData.filter(item =>
    item.id.toString().includes(searchId) &&
    item.name.toLowerCase().includes(searchName.toLowerCase()) &&
    item.phone.toString().includes(searchPhone) &&
    (filterState ? item.state === filterState : true) &&
    (filterCity ? item.city === filterCity : true)
  );

  // Sorting
  const sortedData = [...filteredData].sort((a, b) => {
    const aId = Number(a.id) || 0;
    const bId = Number(b.id) || 0;
    return sortOrder === 'asc' ? aId - bId : bId - aId;
  });

  const toggleSortOrder = () => setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'));


 const downloadExcel = () => {
  const visibleCols = getVisibleColumns();
  const dataToExport = sortedData.map(item => {
    const newItem = {};
    visibleCols.forEach(col => {
      newItem[col.header] = item[col.key];
    });
    return newItem;
  });

  // Create worksheet from data
  const ws = XLSX.utils.json_to_sheet([]);

  XLSX.utils.sheet_add_aoa(ws, [
  ["OrderMinds Freelancing Solutions LLP"],
  ["Freelancer Subscription information for book-keeping"]
], { origin: "A1" });


  // Add date-time row
  const now = new Date();
  XLSX.utils.sheet_add_aoa(ws, [
    [`Downloaded At: ${now.toLocaleString()}`]
  ], { origin: "A3" });

  // Empty row
  XLSX.utils.sheet_add_aoa(ws, [
    []
  ], { origin: "A4" });

  // Add headers and data starting from row 5
  XLSX.utils.sheet_add_json(ws, dataToExport, { origin: "A5", header: visibleCols.map(col => col.header) });

  // Create workbook and append sheet
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "FreelancerPayinData");

  // Export to file
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'Freelancer_Payin_Data.xlsx');
};

   


  const Table = ({ columns, data }) => (
    <div className="overflow-x-auto">
      <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
        <thead>
          <tr className="bg-gray-200">
            {columns.map(({ header, key }, index) => (
              <th key={index} className="px-4 py-2 text-left">
                {header === 'Freelancer ID' ? (
                  <div className="flex items-center">
                    <span>{header}</span>
                    <button
                      onClick={toggleSortOrder}
                      className="ml-2 text-sm text-blue-500 hover:underline"
                    >
                      {sortOrder === 'asc' ? '↑' : '↓'}
                    </button>
                  </div>
                ) : header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="px-4 py-2 text-center text-gray-500">
                No data available
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr key={rowIndex} className="border-b">
                {columns.map(({ key }, colIndex) => (
                  <td key={colIndex} className="px-4 py-2">
                    {row[key] || ''}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="flex-1 p-6 bg-gray-100 ml-[16rem]">
      <h2 className="text-2xl font-semibold mb-4">Freelancer Pay-In Data for book-keeper (fetched from freelancer_basic_info and freelancer_subscription_info)</h2>

      {/* Counts */}
      <div className="mb-2 text-gray-700">
        Total Freelancers: <span className="font-bold">{mappedData.length}</span> | Filtered: <span className="font-bold">{filteredData.length}</span>
      </div>

      {/* Filters */}
      <div className="mb-6 flex flex-wrap gap-4">
        <input
          type="text"
          placeholder="Search by Freelancer ID"
          value={searchId}
          onChange={e => setSearchId(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="text"
          placeholder="Search by Name"
          value={searchName}
          onChange={e => setSearchName(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />
        <input
          type="text"
          placeholder="Search by Phone"
          value={searchPhone}
          onChange={e => setSearchPhone(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md"
        />

        <select
          value={filterState}
          onChange={e => setFilterState(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="">All States</option>
          {uniqueStates.map(state => (
            <option key={state} value={state}>{state}</option>
          ))}
        </select>

        <select
          value={filterCity}
          onChange={e => setFilterCity(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md"
        >
          <option value="">All Cities</option>
          {uniqueCities.map(city => (
            <option key={city} value={city}>{city}</option>
          ))}
        </select>
      </div>

    {/* Toggle View */}
    <div className="mb-4">
      <button
        onClick={() => setShowBookKeeperView(prev => !prev)}
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        {showBookKeeperView ? 'Show Full Info' : 'Show Book Keeper View'}
      </button>
    </div>

    {/* Render Single Table */}
<button
  onClick={downloadExcel}
  className="mb-4 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
>
  📥 Download as Excel
</button>

    <Table
      columns={getVisibleColumns()}
      data={sortedData}
    />
  </div>
);
};

export default BKFreelancerPayInDataPage;
